import React, { useEffect, useState } from "react";
import {
  getAllDashElements,
  getAppId,
  getAllDashPages,
  getRealtimeUsers,
  getAlrayyanStatus,
} from "../../api/api";
import CountryPie from "../graphs/countryPie";
import LineCountry from "../graphs/lineGraph";

const AlHome = () => {
  /* eslint-disable no-unused-vars */
  const [dashElements, setDashElements] = useState([]);
  const [dashPages, setDashPages] = useState([]);
  const [realStats, setRealStats] = useState([]);
  const [actUC, setActUC] = useState([]);
  const [altv, setAlTV] = useState("");
  const [oltv, setOlTV] = useState("");
  const [alatv, setAlaTV] = useState("");
  const [olatv, setOlaTV] = useState("");
  const [actTC, setActTC] = useState([]);
  const [actPC, setActPC] = useState([]);
  const [loading, setLoading] = useState(false);
  /* eslint-disable no-unused-vars */

  useEffect(() => {
    const elementDetail = async () => {
      setLoading(true);
      /* eslint-disable no-unused-vars */

      const result = await getAllDashElements(getAppId()).then(
        (result) => {
          setDashElements(result.data);
          setLoading(false);
        },
        (error) => {
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };

    const pageDetail = async () => {
      setLoading(true);
      /* eslint-disable no-unused-vars */

      const result = await getAllDashPages(getAppId()).then(
        (result) => {
          setDashPages(result.data);
          setLoading(false);
        },
        (error) => {
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };
    const RealTimeStats = async () => {
      setLoading(true);
      /* eslint-disable no-unused-vars */

      const result = await getRealtimeUsers("runRealScreenReport").then(
        (result) => {
          setRealStats(result.data);
          setLoading(false);
        },
        (error) => {
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };

    const ActiveStatus = async () => {
      /* eslint-disable no-unused-vars */
      const alresult = await getAlrayyanStatus(
        "https://35lbvikvo8.execute-api.us-east-2.amazonaws.com/PROD/v1/stream_type?channel=alrayyan"
      ).then(
        (result) => {
          setAlTV(result.data);
          setLoading(false);
        },
        (error) => {
          setLoading(false);
        }
      );

      const olresult = await getAlrayyanStatus(
        "https://35lbvikvo8.execute-api.us-east-2.amazonaws.com/PROD/v1/stream_type?channel=oldrayyan"
      ).then(
        (result) => {
          setOlTV(result.data);
          setLoading(false);
        },
        (error) => {
          setLoading(false);
        }
      );
      const alaresult = await getAlrayyanStatus(
        "https://35lbvikvo8.execute-api.us-east-2.amazonaws.com/PROD/v1/stream_type?channel=alrayyan_audio"
      ).then(
        (result) => {
          setAlaTV(result.data);
          setLoading(false);
        },
        (error) => {
          setLoading(false);
        }
      );

      const olaresult = await getAlrayyanStatus(
        "https://35lbvikvo8.execute-api.us-east-2.amazonaws.com/PROD/v1/stream_type?channel=oldrayyan_audio"
      ).then(
        (result) => {
          setOlaTV(result.data);
          setLoading(false);
        },
        (error) => {
          setLoading(false);
        }
      );
    };
    const ActiveUserCountry = async () => {
      setLoading(true);
      /* eslint-disable no-unused-vars */

      const result = await getRealtimeUsers("rungraphReport").then(
        (result) => {
          setActUC(result.data);

          setLoading(false);
        },
        (error) => {
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };
    const ActiveUserTotal = async () => {
      setLoading(true);
      /* eslint-disable no-unused-vars */

      const result = await getRealtimeUsers("rungraphTopReport").then(
        (result) => {
          setActTC(result.data);
          setLoading(false);
        },
        (error) => {
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };

    const ActivePageTotal = async () => {
      setLoading(true);
      /* eslint-disable no-unused-vars */

      const result = await getRealtimeUsers("runPageReport").then(
        (result) => {
          setActPC(result.data);

          setLoading(false);
        },
        (error) => {
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };

    elementDetail();
    pageDetail();
    RealTimeStats();
    ActiveStatus();
    ActiveUserCountry();
    ActiveUserTotal();
    ActivePageTotal();
  }, []);

  function formatDate(string) {
    var options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(string).toLocaleDateString([], options);
  }

  function filterData(emp, filter) {
    const filtered = emp.filter((item) => {
      return item.dimensionValues[0].value === filter;
    });
    if (filtered.length > 0) {
      return filtered[0].metricValues[0].value;
    } else {
      return "0";
    }
  }

  return (
    <section className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-sm-6 col-md-3">
            <div className="info-box background-2 text-white">
              {/* info-box-icon bg-info elevation-1 */}
              <span className="info-box-icon text-danger">
                <i className="fas fa-eye" />
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Real Time Views</span>
                <span className="info-box-number">
                  {realStats.rowCount > 0
                    ? filterData(realStats.rows, "page_view") + " Views"
                    : "0 Views"}
                  <small />
                </span>
              </div>
              {/* /.info-box-content */}
            </div>
            {/* /.info-box */}
          </div>
          {/* /.col */}
          <div className="col-12 col-sm-6 col-md-3">
            <div className="info-box mb-3  background-2 text-white">
              <span className="info-box-icon text-warning">
                <i className="fas fa-users" />
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Real Time Active Users</span>
                <span className="info-box-number">
                  {" "}
                  {realStats.rowCount > 0
                    ? filterData(realStats.rows, "user_engagement") + " Users"
                    : "0 Users"}
                </span>
              </div>
              {/* /.info-box-content */}
            </div>
            {/* /.info-box */}
          </div>
          {/* /.col */}
          {/* fix for small devices only */}
          <div className="clearfix hidden-md-up" />
          <div className="col-12 col-sm-6 col-md-3">
            <div className="info-box mb-3 background-2 text-white">
              <span className="info-box-icon text-success">
                <i className="fas fa-map" />
              </span>
              <div className="info-box-content">
                <span className="info-box-text">First Time Visits</span>
                <span className="info-box-number">
                  {realStats.rowCount > 0
                    ? filterData(realStats.rows, "first_visit") + " Visits"
                    : "0 Visits"}
                </span>
              </div>
              {/* /.info-box-content */}
            </div>
            {/* /.info-box */}
          </div>
          {/* /.col */}
          <div className="col-12 col-sm-6 col-md-3">
            <div className="info-box mb-3 background-2 text-white">
              <span className="info-box-icon text-info">
                <i className="fas fa-mouse-pointer" />
              </span>
              <div className="info-box-content">
                <span className="info-box-text">User Session Started</span>
                <span className="info-box-number">
                  {realStats.rowCount > 0
                    ? filterData(realStats.rows, "session_start") + " Sessions"
                    : "0 "}
                </span>
              </div>
              {/* /.info-box-content */}
            </div>
            {/* /.info-box */}
          </div>
          {/* /.col */}
        </div>

        <div className="row">
          <div className="col-12 col-sm-6 col-md-3">
            <div className="info-box background-2 text-white">
              {/* info-box-icon bg-info elevation-1 */}
              <span className="info-box-icon text-white">
                <img
                  src="https://alrayyan.tv/wp-content/uploads/2021/03/TVLogo.png"
                  alt="alrayyan logo"
                  style={{ height: "40px", width: "40px" }}
                ></img>
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Alrayyan TV</span>
                <span className="info-box-number">
                  {altv
                    ? altv.stream_type === "primary"
                      ? "Running Main Stream"
                      : "Running Backup Stream"
                    : "No Data"}
                  <small />
                </span>
              </div>
              {/* /.info-box-content */}
            </div>
            {/* /.info-box */}
          </div>
          {/* /.col */}
          <div className="col-12 col-sm-6 col-md-3">
            <div className="info-box background-2 text-white">
              {/* info-box-icon bg-info elevation-1 */}
              <span className="info-box-icon text-white">
                <img
                  src="https://alrayyantv-wp2.alrayyantv-ase.p.azurewebsites.net/wp-content/uploads/2021/04/rayyanqadeem.png"
                  alt="oldrayyan logo"
                  style={{ height: "60px", width: "60px" }}
                ></img>
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Oldrayyan TV</span>
                <span className="info-box-number">
                  {oltv
                    ? oltv.stream_type === "primary"
                      ? "Running Main Stream"
                      : "Running Backup Stream"
                    : "No Data"}
                  <small />
                </span>
              </div>
              {/* /.info-box-content */}
            </div>
            {/* /.info-box */}
          </div>
          {/* /.col */}
          {/* fix for small devices only */}
          <div className="clearfix hidden-md-up" />
          <div className="col-12 col-sm-6 col-md-3">
            <div className="info-box background-2 text-white">
              {/* info-box-icon bg-info elevation-1 */}
              <span className="info-box-icon text-white">
                <img
                  src="https://play-lh.googleusercontent.com/pj8AXr4m7BMoNomLiXzW2p19_pO2YM_LVK1fE-5ZZfGoljW0REr1njCXnFGLwfAqm6c"
                  alt="FM logo"
                  style={{ height: "40px", width: "40px" }}
                ></img>
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Alrayyan FM</span>
                <span className="info-box-number">
                  {alatv
                    ? alatv.stream_type === "primary"
                      ? "Running Main Stream"
                      : "Running Backup Stream"
                    : "No Data"}
                  <small />
                </span>
              </div>
              {/* /.info-box-content */}
            </div>
            {/* /.info-box */}
          </div>
          {/* /.col */}
          <div className="col-12 col-sm-6 col-md-3">
            <div className="info-box background-2 text-white">
              {/* info-box-icon bg-info elevation-1 */}
              <span className="info-box-icon text-white">
                <img
                  src="https://cdn-radiotime-logos.tunein.com/s283296d.png"
                  alt="Radio logo"
                  style={{ height: "40px", width: "40px" }}
                ></img>
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Sout Al Islam Radio</span>
                <span className="info-box-number">
                  {olatv
                    ? olatv.stream_type === "primary"
                      ? "Running Main Stream"
                      : "Running Backup Stream"
                    : "No Data"}
                  <small />
                </span>
              </div>
              {/* /.info-box-content */}
            </div>
            {/* /.info-box */}
          </div>
          {/* /.col */}
        </div>

        <div className="row mb-2 mt-2"></div>

        <div className="row">
          <div className="col-md-6">
            <div className="card background-2">
              <div className="card-header">
                <h3 className="card-title text-white">
                  Last 30 days Active Users by Country
                </h3>
                <div className="card-tools"></div>
              </div>
              {/* /.card-header */}
              <div className="card-body p-0">
                <CountryPie info={actUC}></CountryPie>
              </div>
              {/* /.card-body */}

              {/* /.card-footer */}
            </div>
          </div>
          <div className="col-md-6">
            <div className="card background-2">
              <div className="card-header">
                <h3 className="card-title text-white">
                  Last 15 days User Engagement Rate & Bounce Rate in %
                </h3>
                <div className="card-tools"></div>
              </div>
              {/* /.card-header */}
              <div className="card-body p-0">
                <LineCountry info={actTC}></LineCountry>
              </div>
              {/* /.card-body */}

              {/* /.card-footer */}
            </div>
          </div>
        </div>

        <div className="row mb-2 mt-2"></div>

        <div className="row">
          <div className="col-md-6">
            <div className="card background-2 text-white">
              <div className="card-header">
                <h3 className="card-title">
                  Active Users by Page in Last 30 days
                </h3>
                <div className="card-tools"></div>
              </div>
              {/* /.card-header */}
              <div className="card-body">
                {actPC.map((row, index) => (
                  <div
                    key={index}
                    className="d-flex justify-content-between align-items-center border-bottom mb-3"
                  >
                    <p className="text-success text-xl">
                      <i className="fas fa-user"></i>
                    </p>
                    <p className="d-flex flex-column text-right">
                      <span className="font-weight-bold">
                        <i className="fas fa-eye text-success"></i>{" "}
                        {row.metricValues[0].value + " users"}
                      </span>
                      <span
                        className="text-muted"
                        style={{ color: "#b0b6bb !important" }}
                      >
                        {row.dimensionValues[0].value}
                      </span>
                    </p>
                  </div>
                ))}
              </div>
              {/* /.card-body */}

              {/* /.card-footer */}
            </div>
          </div>

          <div className="col-md-6">
            <div className="card background-2 text-white">
              <div className="card-header">
                <h3 className="card-title">
                  Total Users by Page in Last 30 days
                </h3>
                <div className="card-tools"></div>
              </div>
              {/* /.card-header */}
              <div className="card-body">
                {actPC.map((row, index) => (
                  <div
                    key={index}
                    className="d-flex justify-content-between align-items-center border-bottom mb-3"
                  >
                    <p className="text-success text-xl">
                      <i className="fas fa-user"></i>
                    </p>
                    <p className="d-flex flex-column text-right">
                      <span className="font-weight-bold">
                        <i className="fas fa-eye text-success"></i>{" "}
                        {row.metricValues[1].value + " users"}
                      </span>
                      <span
                        className="text-muted"
                        style={{ color: "#b0b6bb !important" }}
                      >
                        {row.dimensionValues[0].value}
                      </span>
                    </p>
                  </div>
                ))}
              </div>
              {/* /.card-body */}

              {/* /.card-footer */}
            </div>
          </div>
        </div>

        <div className="row mb-2 mt-2"></div>

        <div className="row"></div>
      </div>
    </section>
  );
};

export default AlHome;
